/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_Up_HeadingInputs */

const en_auth_sign_up_heading = /** @type {(inputs: Auth_Sign_Up_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

const es_auth_sign_up_heading = /** @type {(inputs: Auth_Sign_Up_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu cuenta`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Auth_Sign_Up_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_sign_up_heading = /** @type {((inputs?: Auth_Sign_Up_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_Up_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_sign_up_heading(inputs)
	return en_auth_sign_up_heading(inputs)
});